import { CreativeStatus } from 'components/common/types/Creative.types';
import { createSelector } from '@reduxjs/toolkit';

export const getAllSelectedCreativesPendingStatus = createSelector(
  (state) => state.pages.contentManagement.creatives.selectedCreatives,
  (creatives) => creatives.every((creative) => creative.statusCode === CreativeStatus.PENDING),
);

export const getAllSelectedCreativeHaveDefinedDealId = createSelector(
  (state) => state.pages.contentManagement.creatives.selectedCreatives,
  (creatives) =>
    creatives.every((creative) =>
      creative.market?.some((creativeMarket) =>
        creativeMarket.deal?.some((marketDeal) => !!marketDeal.id || !!marketDeal.dealId),
      ),
    ),
);

export const getAllSelectedCreativesPendingAndOrRejected = createSelector(
  (state) => state.pages.contentManagement.creatives.selectedCreatives,
  (creatives) =>
    creatives.every((creative) => [CreativeStatus.PENDING, CreativeStatus.REJECTED].includes(creative.statusCode)),
);

export const getAllSelectedCreativesWithSameDspCode = createSelector(
  (state) => state.pages.contentManagement.creatives.selectedCreatives,
  (creatives) => {
    const isSameDspCode = creatives.every((creative) => creative.dsp?.code === creatives[0]?.dsp?.code);
    return isSameDspCode ? creatives[0]?.dsp?.code : undefined;
  },
);
